import React from "react";
import PropTypes from "prop-types";
import Chip from "@material-ui/core/Chip";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import InputAdornment from "@material-ui/core/InputAdornment";
import { handleOptionSetValue } from "../../../../../Utils/Helpers/optionSet.helper";
import A_FormHelper from "../../DataDisplay/Tooltips/A_FormHelper";

const itemValue = (item) =>
  item && typeof item === "object"
    ? item.value
    : handleOptionSetValue(item, false);

const parseDefaultValues = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map(itemValue);
  if (typeof raw === "object") return [itemValue(raw)];
  try {
    const parsed = JSON.parse(String(raw).replace(/'/g, '"'));
    if (Array.isArray(parsed)) {
      return parsed.map(itemValue);
    }
  } catch {
    /* plain string value */
  }
  return [handleOptionSetValue(String(raw), false)];
};

export default function A_RoleMultiselect(props) {
  const { data, label, options, handleTabsSeletion, fieldHelperText } = props;
  const [values, setValues] = React.useState(() =>
    parseDefaultValues(data && data.defaultValue)
  );
  const locked = React.useRef(props.lockSaved ? values : []).current;
  const optionValue = (option) => handleOptionSetValue(option.value, false);

  const onChange = (e) => {
    const selected = e.target.value;
    setValues(selected);
    handleTabsSeletion(
      options.filter((option) => selected.includes(optionValue(option))),
      data.id
    );
  };

  return (
    <FormControl className={props.className}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={values}
        onChange={onChange}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
        renderValue={(selected) => (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {selected.map((value) => (
              <Chip key={value} size="small" label={value} />
            ))}
          </div>
        )}
        endAdornment={
          fieldHelperText ? (
            <InputAdornment position="end" style={{ marginRight: 16 }}>
              <A_FormHelper fieldHelperText={fieldHelperText} />
            </InputAdornment>
          ) : null
        }
      >
        {options.map((option) => (
          <MenuItem
            key={option.Id}
            value={optionValue(option)}
            disabled={locked.includes(optionValue(option))}
          >
            <Checkbox
              checked={values.includes(optionValue(option))}
              color="primary"
            />
            <ListItemText primary={handleOptionSetValue(option.label)} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

A_RoleMultiselect.propTypes = {
  data: PropTypes.object,
  label: PropTypes.string,
  options: PropTypes.array,
  handleTabsSeletion: PropTypes.func,
  fieldHelperText: PropTypes.string,
  className: PropTypes.string,
  lockSaved: PropTypes.bool,
};
